import { render, staticRenderFns } from "./diagnosis-dialog.vue?vue&type=template&id=f16ad8cc&scoped=true"
import script from "./diagnosis-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./diagnosis-dialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./diagnosis-dialog.vue?vue&type=style&index=0&id=f16ad8cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f16ad8cc",
  null
  
)

export default component.exports